import { lazy } from 'react';

export const AssignmentList = lazy(() => import('./AssignmentList'));
export const AddAssignment = lazy(() => import('./AddAssignment'));
export const UpdateAssignment = lazy(() => import('./UpdateAssignment'));
export const AssignmentFilter = lazy(() => import('./AssignmentFilter'));
